import React, { useState } from 'react'
import { MenuItem, Button, Grid, Box, TextField } from '@material-ui/core'
import { SectionHeader, TextSmall } from '../../theme/typography'
import styled from 'styled-components'

const WrapBox = styled(Box)(({ theme, fullwidth }) => ({
  padding: theme.spacing(2),
  backgroundColor: theme.colors.white,
  borderRadius: 8,
  boxShadow: theme.shadows[3],
  textAlign: 'center',
  [theme.breakpoints.up('sm')]: {
    textAlign: 'left',
    padding: fullwidth ? theme.spacing(1.85, 3) : theme.spacing(3)
  }
}))
const SelectStyled = styled(TextField)(({ theme, error }) => ({
  flex: '1 1 60%',
  width: '60%',
  marginRight: '10px !important',
  height: 'inherit',
  '& > div': {
    height: '100%'
  },
  '& fieldset': {
    borderWidth: error ? 2 : 1,
    borderColor: error ? theme.colors.error : 'none'
  },
  '@media (max-width: 470px)': {
    marginRight: 0,
    marginBottom: 10
  }
}))
const ButtonStyled = styled(Button)(() => ({
  '@media (max-width: 470px)': {
    width: '100%'
  }
}))
const SectionHeaderThinner = styled(SectionHeader)(({ theme }) => ({
  letterSpacing: '1.5px',
  fontSize: '0.875rem',
  lineHeight: 1.2,
  marginBottom: theme.spacing(1)
}))

const GridSelect = styled(Grid)(() => ({
  display: 'flex',
  alignItems: 'center',
  '& > div': {
    width: '100%'
  }
}))

function SelectDevice(props) {
  const [selectedModel, setSelectedModel] = useState('')
  const [error, setError] = useState(false)

  return (
    <WrapBox fullwidth={props.fullwidth} data-ads-event={props.adsEvent}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={props.fullwidth ? 5 : 12}>
          <SectionHeaderThinner component="h2" gutterBottom>
            {props.compatibilityTitle}
          </SectionHeaderThinner>
          <TextSmall
            component="div"
            dangerouslySetInnerHTML={{ __html: props.compatibilityDescription }}
          />
        </Grid>
        <GridSelect item xs={12} md={props.fullwidth ? 7 : 12}>
          <Box display="flex" flexWrap="wrap">
            <SelectStyled
              label={props.compatibilityPlaceholderText}
              placeholder={props.compatibilityPlaceholderText}
              id="select-device"
              variant="outlined"
              fullWidth
              select
              error={error}
              onChange={(e) => {
                setSelectedModel(e.target.value)
                setError(false)
              }}
              value={selectedModel}
            >
              {props.compatibilityModels &&
                props.compatibilityModels.map((model) => {
                  return (
                    <MenuItem key={model.label} value={model.value}>
                      {model.label}
                    </MenuItem>
                  )
                })}
            </SelectStyled>

            <ButtonStyled
              variant="contained"
              color="secondary"
              href={props.compatibilityCtaLink}
              onClick={() => {
                if (!selectedModel) {
                  setError(true)
                  return
                } else {
                  setError(false)
                }
                props.compatibilityCtaOnClick && props.compatibilityCtaOnClick(selectedModel)
              }}
              // disabled={!selectedModel}
            >
              {props.compatibilityCtaText}
            </ButtonStyled>
          </Box>
        </GridSelect>
      </Grid>
    </WrapBox>
  )
}

export default SelectDevice

// SelectDevice.propTypes = {
//   compatibilityTitle: PropTypes.string,
//   compatibilityDescription: PropTypes.string,
//   compatibilityCtaLink: PropTypes.string,
//   compatibilityCtaText: PropTypes.string,
//   compatibilityPlaceholderText: PropTypes.string,
//   compatibilityModels: PropTypes.arrayOf(
//     PropTypes.shape({
//       value: PropTypes.string,
//       label: PropTypes.string
//     })
//   )
// }
